// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"389a43d2","87":"730e13ee","110":"6d5f72ac","163":"544dd412","213":"d18d9ec4","455":"8030010e","502":"f922dfbe","648":"34a5cdea","747":"1b9b55f4","761":"2fa84068","835":"bb134036","940":"a529bc3e"}[chunkId] + ".chunk.js";
};